import React from "react";
import {
  LoaderComponent,
  StyledButton,
  StyledText,
  IconContainer,
} from "./style";

const Button = ({
  style,
  content,
  onClick = () => null,
  load = false,
  greenBase = false,
  outline = false,
  noBackground = false,
  disabled = false,
  round = false,
  square = false,
  border = "#D4D6DA",
  activeBorder = "none",
  iconPosition = "left",
  fontSize = "0.70583rem",
  fontWeight = 700,
  lineHeight = "0.833rem",
  size = "1.5rem",
  iconSize = round || square ? "1.0rem" : "auto",
  padding = round || square ? "0 0 0 0" : "0.82rem 0.2rem 0.7646rem 0.2rem",
  width = round || square ? size : !noBackground ? "100%" : "auto",
  height = round || square ? size : !noBackground ? "100%" : "auto",
  margin,
  marginText = 0,
  colorText,
  background,
  activeBackground,
  activeColorText,
  Icon,
}) => {
  const handleClick = (e) => {
    if (!load) {
      onClick(e);
    }
  };

  return (
    <StyledButton
      style={style}
      colorText={
        colorText ||
        (!noBackground
          ? !outline
            ? !greenBase
              ? "#f4f4f4"
              : "#585E66"
            : "#7E858F"
          : "#BFC2c7")
      }
      onClick={handleClick}
      greenBase={greenBase}
      outline={outline}
      disabled={disabled}
      background={
        background ||
        (!noBackground
          ? !outline
            ? !greenBase
              ? "#585E66"
              : "#40E5A0"
            : "transparent"
          : "transparent")
      }
      border={border}
      activeBackground={
        activeBackground ||
        (!noBackground
          ? !outline
            ? !greenBase
              ? "#333"
              : "#23AB72"
            : border
          : "transparent")
      }
      activeColorText={
        activeColorText ||
        (!noBackground
          ? !outline
            ? !greenBase
              ? "#EEE"
              : "#BEB"
            : "#333"
          : "#7E858F")
      }
      activeBorder={activeBorder}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      borderRadius={!round ? "0.3528rem" : "100%"}
      width={width}
      height={height}
      padding={padding}
      margin={margin}
      iconSize={iconSize}
      load={load}
    >
      <IconContainer>{load && <LoaderComponent active />}</IconContainer>
      {iconPosition === "left" && Icon && <Icon colorText={colorText} />}
      {!!content && !square && !round && (
        <StyledText
          style={{ marginLeft: marginText }}
          fontSize={fontSize}
          fontWeight={fontWeight}
          lineHeight={lineHeight}
        >
          {content}
        </StyledText>
      )}
      {iconPosition === "right" && Icon && <Icon colorText={colorText} />}
    </StyledButton>
  );
};

export default Button;
